'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ToolbarButton = require('./ToolbarButton');

var _ToolbarButton2 = _interopRequireDefault(_ToolbarButton);

var _EditListPlugin = require('../plugins/EditListPlugin');

var _EditListPlugin2 = _interopRequireDefault(_EditListPlugin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isSelectionInList = _EditListPlugin2.default.utils.isSelectionInList;
var _EditListPlugin$chang = _EditListPlugin2.default.changes,
    unwrapList = _EditListPlugin$chang.unwrapList,
    wrapInList = _EditListPlugin$chang.wrapInList;


var ListBlockButton = function ListBlockButton(_ref) {
  var block = _ref.block,
      icon = _ref.icon,
      text = _ref.text,
      title = _ref.title,
      value = _ref.value,
      data = _ref.data,
      onChange = _ref.onChange;

  var inList = isSelectionInList(value);
  var activeInListType = inList && value.blocks.some(function (lookBlock) {
    return !!value.document.getClosest(lookBlock.key, function (parent) {
      return parent.type === block;
    });
  });

  return _react2.default.createElement(_ToolbarButton2.default, {
    icon: icon,
    text: text,
    title: title,
    onMouseDown: function onMouseDown() {
      // Unwrap list if same list button is hit as the active list
      if (activeInListType) {
        return onChange(unwrapList(value.change(), block));
      }
      // rewrap list if different list block
      if (inList) {
        return onChange(wrapInList(unwrapList(value.change(), block), block, data));
      }
      // wrap list if no list
      return onChange(wrapInList(value.change(), block, data));
    },
    active: activeInListType
  });
};

ListBlockButton.propTypes = {
  block: _propTypes2.default.string.isRequired,
  icon: _propTypes2.default.string.isRequired,
  text: _propTypes2.default.string,
  title: _propTypes2.default.string,
  value: _propTypes2.default.object.isRequired,
  data: _propTypes2.default.object,
  onChange: _propTypes2.default.func.isRequired
};

exports.default = ListBlockButton;